module.exports = __webpack_public_path__ + "img/wow-cover.ccf62fa6.jpg";